import { InternalUser } from '../../apis/users/users.api.interfaces';
import { UserStatus } from '../../apis/users/users.api.interfaces';

export const mockInternalUsers: InternalUser[] = [
  {
    id: 'internal-001',
    firstName: 'Rahul',
    lastName: 'Sharma',
    middleName: '',
    email: 'rahul.sharma@institute.com',
    phone: '+91-9876543210',
    status: UserStatus.ACTIVE,
    userRole: 'internal_staff',
    hasStaffRecord: true,
    createdDate: '2025-06-01T12:00:00.000Z',
    lastActive: '2026-05-01T10:00:00.000Z',
  },
  {
    id: 'internal-002',
    firstName: 'Priya',
    lastName: 'Gupta',
    middleName: '',
    email: 'priya.gupta@institute.com',
    phone: '+91-9876543211',
    status: UserStatus.ACTIVE,
    userRole: 'teacher',
    hasStaffRecord: false,
    createdDate: '2025-08-15T09:00:00.000Z',
    lastActive: '2026-05-05T14:00:00.000Z',
  },
  {
    id: 'internal-003',
    firstName: 'Amit',
    lastName: 'Verma',
    middleName: 'K',
    email: 'amit.verma@institute.com',
    phone: '+91-9876543212',
    status: UserStatus.ACTIVE,
    userRole: 'admin_role',
    hasStaffRecord: true,
    createdDate: '2025-03-01T08:00:00.000Z',
    lastActive: '2026-05-06T16:00:00.000Z',
  },
  {
    id: 'internal-004',
    firstName: 'Sneha',
    lastName: 'Patel',
    middleName: '',
    email: 'sneha.patel@institute.com',
    phone: '+91-9876543213',
    status: UserStatus.PENDING,
    userRole: 'external_staff',
    hasStaffRecord: false,
    createdDate: '2026-04-20T11:00:00.000Z',
    lastActive: '2026-04-20T11:00:00.000Z',
  },
];

export const mockInternalUsersSummary = {
  totalUsers: 4,
  activeUsers: 3,
  pendingUsers: 1,
  blockedUsers: 0,
  recentlyAdded: 1,
  statusDistribution: {
    active: 3,
    inactive: 0,
    pending: 1,
    blocked: 0,
  },
};
